// extracted by mini-css-extract-plugin
export default {"heroHeader":"CoronationGown_heroHeader__yUSQT","adj1":"CoronationGown_adj1__fHgxL","adj2":"CoronationGown_adj2__oA6IV","adj3":"CoronationGown_adj3__7j0Fl"};